import axios from "infra/http";
import { useQuery } from "react-query";
import {
  UnidadeHistoricoPessoaLog,
} from "core/features/unidades/typings/unidade";

function useHistoricoUnidade(id: string | undefined) {
  return useQuery(
    `/v1/unidades/${id}/historico`,
    async () => {
      const {data} = await axios.get<UnidadeHistoricoPessoaLog[]>(
        `/v1/unidades/${id}/historico`
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useHistoricoUnidade;
